import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import React from 'react';
import { useParams } from 'react-router-dom';

const VendorStoreCctv = () => {
    const { storeNo } = useParams();

    return (
        <VerticalFlex>
            <FlexChild>
                <div>VendorStoreCctv storeId : {storeNo}</div>
            </FlexChild>
        </VerticalFlex>
    );
};

export default VendorStoreCctv;